export default __webpack_public_path__ + "static/media/Stock token icon_black.5522c3e8.svg";